import nativeCreate from "./component-library398.mjs";
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}
export {
  hashClear as default
};
